(function () {
  "use strict";

  var analyticsLoaded = false;
  var requireConsent = Boolean(
    document.currentScript &&
      document.currentScript.dataset.requireConsent === "true",
  );

  function appendScript(src, id, onload) {
    if (id && document.getElementById(id)) return;

    var script = document.createElement("script");
    script.async = true;
    script.src = src;
    if (id) script.id = id;
    if (onload) script.onload = onload;
    document.head.appendChild(script);
  }

  function loadMetricool() {
    appendScript(
      "https://tracker.metricool.com/resources/be.js",
      "metricool-script",
      function () {
        if (window.beTracker && typeof window.beTracker.t === "function") {
          window.beTracker.t({ hash: "776e7bd4f68a8f8a3726c8cd64d05ce1" });
        }
      },
    );
  }

  function loadHotjar() {
    window.hj =
      window.hj ||
      function () {
        (window.hj.q = window.hj.q || []).push(arguments);
      };
    window._hjSettings = { hjid: 1974067, hjsv: 6 };
    appendScript(
      "https://static.hotjar.com/c/hotjar-1974067.js?sv=6",
      "hotjar-script",
    );
  }

  function loadClarity() {
    window.clarity =
      window.clarity ||
      function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };
    appendScript(
      "https://www.clarity.ms/tag/bsdvfi0j59",
      "clarity-script",
    );
  }

  function loadAnalytics() {
    if (analyticsLoaded) return;
    analyticsLoaded = true;
    loadMetricool();
    loadHotjar();
    loadClarity();
    appendScript(
      "https://js.hs-scripts.com/7773117.js",
      "hs-script-loader",
    );
    // Lets scripts that ran before consent was known send deferred analytics.
    document.dispatchEvent(new CustomEvent("theme:analytics-loaded"));
  }

  function analyticsAllowed() {
    return Boolean(
      window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed ===
          "function" &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed(),
    );
  }

  function evaluateConsent() {
    if (analyticsAllowed()) loadAnalytics();
  }

  function initializeConsent(attempt) {
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function (error) {
          if (!error) evaluateConsent();
        },
      );
      return;
    }

    if (attempt < 100) {
      window.setTimeout(function () {
        initializeConsent(attempt + 1);
      }, 100);
    }
  }

  if (!requireConsent) {
    loadAnalytics();
    return;
  }

  document.addEventListener("visitorConsentCollected", evaluateConsent);
  initializeConsent(0);
})();
